import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import Slider from '@unlikelystudio/react-slider'

import InlineCta, { InlineCtaProps } from '~/components/UI/InlineCta'

import { useStyle } from '~/providers/StyleProvider'

import { GENERAL } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type ShopsNavigationProps = {
  className?: string
  items?: InlineCtaProps[]
}

function ShopsNavigation({ className, items }: ShopsNavigationProps) {
  const t = useTranslate()
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Grotesk,
    textStyling: GlobalTextStyling.UpperCase,
  })
  return (
    items?.length > 0 && (
      <div className={cx(css.ShopsNavigation, className, gridStyle)}>
        <div className={cx(css.left, titleStyle)}>{`${t(GENERAL.SHOPS)} (${
          items?.length
        })`}</div>
        <div className={cx(css.right)}>
          <Slider autoIsSlider={true}>
            {items?.map((item, index) => {
              const { active, ...props } = item
              return (
                <InlineCta
                  key={`shop_navigation_${index}`}
                  className={cx(css.link, { active })}
                  textPreset={GlobalTextPreset.Cta12Grotesk}
                  theme={
                    active ? GlobalThemeColors.Black : GlobalThemeColors.Gray
                  }
                  lineProps={{ initialLineState: 'none' }}
                  {...props}
                />
              )
            })}
          </Slider>
        </div>
      </div>
    )
  )
}

ShopsNavigation.defaultProps = {}

export default ShopsNavigation
